import actions from '../action/rc'
import CONSTANT from '../constant/rc'
import _ from 'underscore'

export default {
  actions,
  state: {
    app: {
      showAppTip: false,
      src: 1,
      action: '',
    }
  },
  mutations: {
    [CONSTANT.RC_APPTIP_SET_APPSRC] (state, {src, action = ''}) {
      state.app = Object.assign({}, state, Object.assign({}, state.app, {src, action}))
    },
    [CONSTANT.RC_APPTIP_SET_ENABLE](state) {
      state.app = Object.assign({}, state, Object.assign({}, state.app, {showAppTip: true}))
    },
    [CONSTANT.RC_APPTIP_SET_DISABLE](state) {
      state.app = Object.assign({}, state, Object.assign({}, state.app, {showAppTip: false}))
    }
  },
}
